import React from "react";
import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";

// A control's status on the public page: an icon and the word, no filled
// pill, so a long list of passing controls stays calm and a failing one
// still stands out. Nothing is shown for a hidden status.
const StatusMark = ({ status }) => {
  const theme = useTheme();
  const t = theme.trust || {};
  if (status !== "pass" && status !== "fail") return null;
  const pass = status === "pass";
  const color = pass
    ? t.verified || theme.customColors.status.success.text
    : t.attention || theme.customColors.status.warning.text;
  const Icon = pass ? CheckCircleRoundedIcon : ErrorRoundedIcon;
  return (
    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ flexShrink: 0, color }}>
      <Icon aria-hidden="true" sx={{ fontSize: 16 }} />
      <Typography component="span" sx={{ fontSize: 13, fontWeight: 500, color }}>
        {pass ? "Passing" : "Failing"}
      </Typography>
    </Stack>
  );
};

export default StatusMark;
